import { css } from '@emotion/react';
import { colors } from '@/styles';

// Stops row-click propagation so it can sit inside a clickable table row.
const DocumentLink = ({ href, children }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        css={css`
            color: ${colors.greens.primary};
            text-decoration: underline;
        `}
    >
        {children}
    </a>
);

export default DocumentLink;
